var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"complexProd"},[_c('h4',[_vm._v(_vm._s(_vm.obj.title))]),_c('p',[_vm._v(_vm._s(_vm.obj.text))]),_c('img',{attrs:{"src":_vm.obj.url}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }